import { useCallback, useState } from "react";

import { SourceCreationView } from "../SourceCreation.constants";

/**
 * Tracks whether the form or the post-create field mapping view is shown,
 * and which source the mapping belongs to.
 */
const useSourceMappingView = () => {
    const [view, setView] = useState(SourceCreationView.FORM);
    const [mappingSourceId, setMappingSourceId] = useState(null);
    const [mappingSourceType, setMappingSourceType] = useState(null);
    const [mappingSourceTypeId, setMappingSourceTypeId] = useState(null);

    const openMapping = useCallback((sourceId, sourceType, sourceTypeId) => {
        if (!sourceId || !sourceType) return;
        setMappingSourceId(sourceId);
        setMappingSourceType(sourceType);
        setMappingSourceTypeId(sourceTypeId ?? null);
        setView(SourceCreationView.MAPPING);
    }, []);

    const closeMapping = useCallback(() => {
        setView(SourceCreationView.FORM);
        setMappingSourceType(null);
        setMappingSourceTypeId(null);
    }, []);

    return {
        view,
        isMappingView: view === SourceCreationView.MAPPING,
        mappingSourceId,
        mappingSourceType,
        mappingSourceTypeId,
        openMapping,
        closeMapping,
    };
};

export default useSourceMappingView;
